import header from "./stadtmetropole.jpg";
import section1 from "./hauseingang-mit-steg.jpg";
import section2 from "./telefonierender-mensch-vor-haus.jpg";
import section3 from "./modell-haeuser-in-haenden.jpg";
import section4 from "./erfolgreicher-vertragsabschluss.jpg";
import section5 from "./tiefgarage.jpg";
import section6 from "./skizzen.jpg";
import section7 from "./sortierung-eines-ordners.jpg";
import section8 from "./unternehmens-besprechung.jpg";
import section9 from "./durchlesen-eines-vertrages.jpg";
import section10 from "./vertrag-unterschrift.jpg";
import section11 from "./unterzeichneter-vertrag.jpg";

export {
  header,
  section1,
  section10,
  section11,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
